




































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import AccountListApi from '@/app/model/api/accountListApi'
import AccountCreateApi from '@/app/model/api/accountCreateApi'
import GroupListApi from '@/app/model/api/groupListApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import Validator from '@/app/module/validator'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorModal,
    ErrorInfo
  }
})
export default class AccountCreate extends Vue {
  private account: string = ''
  private name: string = ''
  private groupname: string = ''
  private groupList: any = []
  private tel: string = ''
  private email: string = ''
  private password: string = ''
  private remarks: string = ''
  private errorMessages: any = ''
  private choiceField: number[] = []
  private choiceFiledName: string[] = []
  private alertText: string = ''
  private alertTitle: string = ''
  private show400ErrorMessage: boolean = false
  private constantValue: any = []

  /* パスワード自動生成 */
  private displayPassword () {
    this.password = this.createPassword()
  }

  private createPassword () {
    let str: string = 'abcdefghijklmnopqrstuvwxyz0123456789!"#$%&()_-'
    let len: number = 12

    let result: string = ''
    for (var i = 0; i < len; i++) {
      result += str.charAt(Math.floor(Math.random() * str.length))
    }

    return result
  }

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.getGroupList()
  }

  private getGroupList () {
    (async () => {
      /* 初期表示はグループ名の昇順 */
      let data: any = {
        order_name: 'group_name',
        sort: 'asc',
        text: ''
      }

      const result = await GroupListApi.getGroupList(data)
      if (result.isOk()) {
        this.groupList = result.getPayload().groups
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    })()
  }

  private async accountCreate () {
    let fieldIdList: number[] = []

    /* バリデーションチェック */
    if (!this.isAccountCreate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }

    const bodyData = {
      'name': this.name,
      'user_type': parseInt(this.account),
      'tell': this.tel,
      'mailaddress': this.email,
      'group_id': parseInt(this.groupname),
      'password': this.password,
      'remarks': this.remarks
    }

    /* ユーザー登録処理が成功したらユーザー一覧に遷移、失敗したらアラートを表示 */
    const result = await AccountCreateApi.doAccountCreate(bodyData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: 'ユーザー登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/user').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      this.alertText = errorData.alertText
      this.alertTitle = errorData.alertTitle
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
    }
  }

  private getSelectData () {
    (async () => {
      const result = await AccountListApi.getAccountList('')

      if (result.isOk()) {
        this.groupList = result.getPayload().groups
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    })()
  }

  private isAccountCreate () {
    const accountFlag = Validator.validateInputAccount('accountErrorMessage', parseInt(this.account))
    const nameFlag = Validator.validateInputName('nameErrorMessage', this.name)
    const telFlag = Validator.validateInputTel('telErrorMessage', this.tel)
    const emailFlag = Validator.validateInputEmail('emailErrorMessage', this.email)
    const passwordFlag = Validator.validateInputPassword('passwordErrorMessage', this.password)
    const groupFlag = Validator.validateInputGroup('groupErrorMessage', this.groupname)

    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    return accountFlag && nameFlag && telFlag && emailFlag && passwordFlag && groupFlag
  }

  /* ユーザーリストへ戻る */
  private doCancel () {
    this.$router.push('/master/user').catch(e => {})
  }

  private displayRemarks (data: string) {
    if (data !== '' && data !== undefined) {
      if (data.length > 20) {
        return data.substr(0, 20) + '…'
      } else {
        return data
      }
    }
  }
}
